import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

export const ToastNotification = ReactNotification
